import { render, staticRenderFns } from "./messageDetail.vue?vue&type=template&id=f8e76f98&scoped=true"
import script from "./messageDetail.vue?vue&type=script&lang=js"
export * from "./messageDetail.vue?vue&type=script&lang=js"
import style0 from "./messageDetail.vue?vue&type=style&index=0&id=f8e76f98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e76f98",
  null
  
)

export default component.exports